import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}><path d="M21.12 4.576H5.728v22.848h20.544V11.04zM24 25.152H8V6.848h12.032L24 11.84zm-4.576-11.424a1.154 1.154 0 01.007 2.271l-.007.001h-6.848a1.154 1.154 0 01-.007-2.271l.007-.001zm-2.272 5.696c0 .636-.516 1.152-1.152 1.152h-3.424a1.152 1.152 0 010-2.304H16c.636 0 1.152.516 1.152 1.152" /></svg>;